import { render, staticRenderFns } from "./PatientSomatometry.vue?vue&type=template&id=51cd122d&"
import script from "./PatientSomatometry.vue?vue&type=script&lang=js&"
export * from "./PatientSomatometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports